// extracted by mini-css-extract-plugin
export default {"downloadButton":"_20ZPl___MediaDownloader-module__downloadButton"};